var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"material-icons mr-2",on:{"click":function($event){return _vm.voiceSearch()}}},[_vm._v("keyboard_voice")])])}
var staticRenderFns = []

export { render, staticRenderFns }